import { render, staticRenderFns } from "./friendRecall.vue?vue&type=template&id=5f633e48&"
import script from "./friendRecall.vue?vue&type=script&lang=js&"
export * from "./friendRecall.vue?vue&type=script&lang=js&"
import style0 from "./friendRecall.vue?vue&type=style&index=0&id=5f633e48&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports